import { Box, VStack, Center, Text, AspectRatio } from "@chakra-ui/react";
import RenderTextWithBreaks from "../../utils/indention";

type Props = {
  title?: string;
  content?: string;
  video?: string;
};

const InterviewContent: React.FC<Props> = ({ title, content, video }) => {
  return (
    <Box mt={"16px"}>
      <Center>
        <VStack>
          <Box
            bg={"#1DC6FC"}
            p={2}
            pl={30}
            w={"90vw"}
            maxW={"512px"}
            borderRadius={5}
          >
            <Text color={"white"} fontWeight={700}>
              {title ?? "none"}
            </Text>
          </Box>
          <Box w={"80vw"} maxW={"480px"} pr={4}>
            <RenderTextWithBreaks
              inputStr={content ?? "none"}
              textColor={"#626262"}
              fontWeight={700}
              fontSize="md"
            />
          </Box>
          {video ? (
            <>
              <AspectRatio maxW={"480px"}>
                <iframe
                  title={video}
                  src={video ?? "none"}
                  width={"80vw"}
                  allowFullScreen
                ></iframe>
              </AspectRatio>
            </>
          ) : (
            <div></div>
          )}
        </VStack>
      </Center>
    </Box>
  );
};

export default InterviewContent;
